import { RoofShape } from "@covertree/agent-portal-graphql";

export const mapRoofShape = (roofShape: RoofShape): string => {
  switch (roofShape) {
    case RoofShape.NotListed:
      return "Not Listed";
    case RoofShape.BowedCurvedArched:
      return "Bowed/Curved/Arched";
    default:
      return roofShape;
  }
};
